export default "__VITE_ASSET__BT9hpHme__"